import React, { useState, useEffect, useContext, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import axios from 'axios';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Button,
  Divider,
  SvgIcon,
  Tooltip,
  IconButton,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Hidden,
  Typography,
} from "@material-ui/core";
import QRCode from "react-qr-code";

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { PageContext } from "../../contexts/PageContext";

const useStyles = makeStyles((theme) => ({
  fabIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: "fixed",
    right: 20,
    bottom: 20,
    zIndex: 10
  },
  signatureList: {
    width: "100%"
  },
  signatureListItemText: {
    [theme.breakpoints.up('md')]: {
      "&>span": {
        display: "flex",
        justifyContent: "space-between"
      }
    },
  },
  signNowButton: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 10
    },
  },
  statusChip: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 10,
      marginRight: "auto"
    }
  },
  signDialog: {
    textAlign: "center"
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));


export default function PortalSignatures(
  {
    portal,
    portalAccessToken,
    setPortal
  }) {
  const theme = useTheme();
  const classes = useStyles();
  const [signatureForSign, setSignatureForSign] = useState(false);
  const [signatureToken, setSignatureToken] = useState("");
  const [signatureViewer, setSignatureViewer] = useState("");
  const pageContext = useContext(PageContext);
  const signFrame = useRef()

  // useEffect(() => {

  // }, [portal]);


  // const savePortalFields = (done = false) => {
  //   savePortal({
  //     id: portal.id,
  //     status: (done ? "fields_done" : portal.status),
  //     fields_settings: signatures
  //   }, () => {
  //     if( done )
  //       pageContext.setInfoMessage("Vielen Dank! Ihre Eingaben wurden an Ihren Berater gesendet.")
  //     else
  //       pageContext.setInfoMessage("Ihre Eingaben wurden gespeichert.")
  //   });
  // }

  const sign = (signature) => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/customerportal/signatureviewer/${signature.id}/${portal.key}`,
      method: 'put',
      data: {
        token: signatureToken
      },
      headers: {
        "X-Portal-Access-Token": portalAccessToken,
      },
    };
    axios(options)
      .then((res) => {
        setSignatureToken(res.data.token)
        setSignatureForSign({ ...signature, url: res.data.url });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message)
          pageContext.setErrorMessage(err.response.data.message);
        else
          pageContext.setErrorMessage("Der Link zur Unterschrift konnte nicht geladen werden.");
      });
  }

  const refreshSignatures = () => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/customerportal/signatures/${portal.id}/${portal.key}`,
      method: 'get',
      headers: {
        "X-Portal-Access-Token": portalAccessToken,
      },
    };
    axios(options)
      .then((res) => {

        setPortal(portal => { return { ...portal, signatures: res.data } })
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message)
          pageContext.setErrorMessage(err.response.data.message);
        else
          pageContext.setErrorMessage("Die Unterschriften konnten nicht aktualisiert werden.");
      });
  }

  if (!portal || !portal.signatures)
    return <></>
  return (
    <>
      <List className={classes.signatureList}>
        <Divider />
        {portal.signatures.map(signature => {
          return (
            <div key={signature.id}>
              <ListItem>
                <ListItemIcon>
                  <SvgIcon>
                    <path fill="currentColor" d="M9.75 20.85C11.53 20.15 11.14 18.22 10.24 17C9.35 15.75 8.12 14.89 6.88 14.06C6 13.5 5.19 12.8 4.54 12C4.26 11.67 3.69 11.06 4.27 10.94C4.86 10.82 5.88 11.4 6.4 11.62C7.31 12 8.21 12.44 9.05 12.96L10.06 11.26C8.5 10.23 6.5 9.32 4.64 9.05C3.58 8.89 2.46 9.11 2.1 10.26C1.78 11.25 2.29 12.25 2.87 13.03C4.24 14.86 6.37 15.74 7.96 17.32C8.3 17.65 8.71 18.04 8.91 18.5C9.12 18.94 9.07 18.97 8.6 18.97C7.36 18.97 5.81 18 4.8 17.36L3.79 19.06C5.32 20 7.88 21.47 9.75 20.85M18.96 7.33L13.29 13H11V10.71L16.67 5.03L18.96 7.33M22.36 6.55C22.35 6.85 22.04 7.16 21.72 7.47L19.2 10L18.33 9.13L20.93 6.54L20.34 5.95L19.67 6.62L17.38 4.33L19.53 2.18C19.77 1.94 20.16 1.94 20.39 2.18L21.82 3.61C22.06 3.83 22.06 4.23 21.82 4.47C21.61 4.68 21.41 4.88 21.41 5.08C21.39 5.28 21.59 5.5 21.79 5.67C22.08 5.97 22.37 6.25 22.36 6.55Z" />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText className={classes.signatureListItemText}>
                  <Typography variant="overline">{signature.title}</Typography>
                  {signature.status === "open"
                    &&
                    <Chip
                      size="small"
                      label="Wartet auf Ihre Unterschrift"
                      className={classes.statusChip}
                      icon={<HourglassEmptyIcon />}
                    />
                  }
                  {signature.status === "closed"
                    &&
                    <Chip
                      size="small"
                      label="Fertig unterschrieben"
                      className={classes.statusChip}
                      color="secondary"
                      icon={<CheckCircleIcon />}
                    />
                  }


                  {signature.status === "open"
                    &&
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.signNowButton}
                      onClick={() => {
                        sign(signature);
                      }}
                      color="secondary"
                    >
                      jetzt unterschreiben
                    </Button>
                  }
                </ListItemText>
              </ListItem>
              <Divider />
            </div>
          )
        }
        )}
      </List>
      <Dialog
        onClose={() => {
          setSignatureForSign(false);
          refreshSignatures();
        }}
        className={classes.signDialog}
        open={Boolean(signatureForSign)}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => {
              setSignatureForSign(false);
              refreshSignatures();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {
            signatureForSign.url
              ? <div>
                <Hidden mdDown>
                  <QRCode
                    value={signatureForSign.url}
                    size={180}
                  />
                  <br />
                  <Typography variant="caption">Auf Mobilgerät öffnen</Typography>
                  <br />
                </Hidden>
                <br />
                <Button
                  href={signatureForSign.url}
                  variant="contained"
                  target="_blank">
                  Dokument "{signatureForSign.title}" öffnen
                </Button>
              </div>
              : <></>
          }
          {/* {signatureForSign.url
            ? <iframe ref={signFrame} className={classes.frame} src={signatureForSign.url} />
            : <></>
          } */}
        </DialogContent>
      </Dialog>
    </>
  );
}
